import type {ReccoRecommendationTypeDTO} from '@/ts/types/dto/recco/recommendation.dto';
import type {ReccoIdDTO} from '@/ts/types/dto/recco/recco-id.dto';

/** User rating values for Recco content */
export enum ReccoRatingDTO {
  LIKE = 'like',
  DISLIKE = 'dislike',
  NOT_RATED = 'not_rated',
}

/** Request payload to submit a like, dislike, or reset rating on a content item */
export interface ReccoPutRatingRequest {
  contentId: ReccoIdDTO;
  contentType: ReccoRecommendationTypeDTO;
  rating: ReccoRatingDTO;
}
